"use client";

interface FollowersChangeProps {
  value: number | null;
}

export function FollowersChange({ value }: FollowersChangeProps) {
  if (value === null || value === undefined) {
    return <span className="text-[#8f98a0]">—</span>;
  }

  const isPositive = value > 0;
  const isNegative = value < 0;
  const isZero = value === 0;

  const formattedValue = Math.abs(value).toLocaleString("en-US");
  const sign = isPositive ? "+" : isNegative ? "-" : "";

  return (
    <span
      className={`text-sm font-medium ${
        isPositive
          ? "text-green-400"
          : isNegative
            ? "text-red-400"
            : "text-[#8f98a0]"
      }`}
    >
      {isZero ? "0" : `${sign}${formattedValue}`}
    </span>
  );
}

